// For full documentation see
// https://github.com/eBayClassifiedsGroup/react-advertising/wiki/Configuration#size-mappings
const viewports = {
  desktop: [1380, 0],
  desktop_s: [1080, 0],
  tablet: [970, 0],
  tablet_s: [862, 0],
  mobile: [768, 0],
  mobile_s: [320, 0],
  all: [0, 0],
}

const sizes = {
  button: [300, 100],
  button_s: [300, 50],
  buttonAds: [320, 100],
  buttonAds_s: [320, 50],
  fullSize: [468, 60],
  largeLeaderBoard: [970, 90],
  largeLeaderBoard_s: [728, 90],
  rectangle: [300, 250],
  billboard: [970, 250],
  billboard_s: [728, 200],
  superBanner: [970, 150],
  superBanner_s: [728, 150],
  sky: [300, 600],
  sky_s: [160, 600],
  wallpaper: [1920, 1080],
}

const sizeCombos = {
  buttons: [sizes.buttonAds, sizes.buttonAds_s, sizes.button, sizes.button_s],
  buttons_s: [sizes.buttonAds_s, sizes.button_s],
  largeLeaderboards: [sizes.superBanner, sizes.largeLeaderBoard, sizes.largeLeaderBoard_s],
}

// Config for Südtirol News
const stolConfig = {
  // GPT size mapping definitions (object). Ideally there is a sizeMapping for each Slot
  viewports: viewports,
  sizeMappings: {
    // Homepage
    SB: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.mobile_s,
        sizes: sizeCombos.buttons,
      },
      {
        viewPortSize: viewports.mobile,
        sizes: [sizes.superBanner_s],
      },
      {
        viewPortSize: viewports.tablet,
        sizes: sizeCombos.largeLeaderboards,
      },
    ],
    SKY: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.mobile_s,
        sizes: sizeCombos.buttons_s,
      },
      {
        viewPortSize: viewports.mobile,
        sizes: [sizes.largeLeaderBoard_s],
      },
      {
        viewPortSize: viewports.desktop,
        sizes: [sizes.sky, sizes.sky_s],
      },
    ],
    REC: [
      {
        viewPortSize: viewports.all,
        sizes: [sizes.rectangle],
      },
    ],
    FS: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.mobile_s,
        sizes: sizeCombos.buttons,
      },
      {
        viewPortSize: viewports.desktop_s,
        sizes: [sizes.fullSize],
      },
    ],
    LL_NO_MOBILE: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.tablet,
        sizes: sizeCombos.largeLeaderboards,
      },
    ],
    LL: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.mobile_s,
        sizes: sizeCombos.buttons,
      },
      {
        viewPortSize: viewports.mobile,
        sizes: [sizes.largeLeaderBoard_s],
      },
      {
        viewPortSize: viewports.tablet,
        sizes: sizeCombos.largeLeaderboards,
      },
    ],
    BB: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.mobile_s,
        sizes: [sizes.rectangle],
      },
      {
        viewPortSize: viewports.mobile,
        sizes: [sizes.largeLeaderBoard_s],
      },
      {
        viewPortSize: viewports.desktop_s,
        sizes: [sizes.billboard],
      },
    ],
    BUTTON: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.mobile_s,
        sizes: [sizes.button],
      },
    ],
    BUTTON_Desktop: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.desktop_s,
        sizes: [sizes.button],
      },
    ],
    WALLPAPER: [
      {
        viewPortSize: viewports.all,
        sizes: [],
      },
      {
        viewPortSize: viewports.tablet,
        sizes: [sizes.wallpaper],
      },
    ],
  },

  // array of slot configurations
  slots: [
    // Homepage
    {
      // ID of the div
      id: 'dlab_ad_H1',

      // slot's ad unit path
      path: '/2273514/stol7_hp_sb',

      // name of sizeMapping that is defined for this slot
      sizeMappingName: 'SB',
    },
    {
      id: 'dlab_ad_H2',
      path: '/2273514/stol7_hp_sky',
      sizeMappingName: 'SKY',
    },
    {
      id: 'dlab_ad_H3',
      path: '/2273514/stol7_hp_fs_1',
      sizeMappingName: 'FS',
    },
    {
      id: 'dlab_ad_H4',
      path: '/2273514/stol7_hp_fs_2',
      sizeMappingName: 'FS',
    },
    {
      id: 'dlab_ad_H5',
      path: '/2273514/stol7_hp_rec_1',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_H6',
      path: '/2273514/stol7_hp_rec_2',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_H7',
      path: '/2273514/stol7_hp_ll_1',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H8',
      path: '/2273514/stol7_hp_ll_2',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H9',
      path: '/2273514/stol7_hp_rec_3',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_H10',
      path: '/2273514/stol7_hp_rec_4',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_H11',
      path: '/2273514/stol7_hp_ll_3',
      sizeMappingName: 'LL_NO_MOBILE',
    },
    {
      id: 'dlab_ad_H12',
      path: '/2273514/stol7_hp_but_1',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_H13',
      path: '/2273514/stol7_hp_but_2',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_H14',
      path: '/2273514/stol7_hp_but_3',
      sizeMappingName: 'BUTTON_Desktop',
    },
    {
      id: 'dlab_ad_H15',
      path: '/2273514/stol7_hp_ll_4',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H16',
      path: '/2273514/stol7_hp_rec_5',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_H17',
      path: '/2273514/stol7_hp_rec_6',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_H18',
      path: '/2273514/stol7_hp_bb',
      sizeMappingName: 'BB',
    },
    {
      id: 'dlab_ad_H21',
      path: '/2273514/stol7_hp_ll_5',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H22',
      path: '/2273514/stol7_hp_ll_6',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H23',
      path: '/2273514/stol7_hp_ll_7',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H24',
      path: '/2273514/stol7_hp_ll_8',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H25',
      path: '/2273514/stol7_hp_ll_9',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H26',
      path: '/2273514/stol7_hp_ll_10',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H27',
      path: '/2273514/stol7_hp_ll_11',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H28',
      path: '/2273514/stol7_hp_ll_12',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_H29',
      path: '/2273514/stol7_hp_ll_13',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_WALLPAPER',
      path: '/2273514/stol7_wallpaper',
      sizeMappingName: 'WALLPAPER',
    },
    {
      id: 'dlab_ad_S1',
      path: '/2273514/stol7_default_sb',
      sizeMappingName: 'SB',
    },
    {
      id: 'dlab_ad_S2',
      path: '/2273514/stol7_default_sky',
      sizeMappingName: 'SKY',
    },
    {
      id: 'dlab_ad_S3',
      path: '/2273514/stol_default_fs_1',
      sizeMappingName: 'FS',
    },
    {
      id: 'dlab_ad_S4',
      path: '/2273514/stol_default_fs_2',
      sizeMappingName: 'FS',
    },
    {
      id: 'dlab_ad_S5',
      path: '/2273514/stol_default_rec_1',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_S6',
      path: '/2273514/stol_default_rec_2',
      sizeMappingName: 'REC',
    },
    {
      id: 'dlab_ad_S7',
      path: '/2273514/stol_default_ll_1',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_S8',
      path: '/2273514/stol_default_ll_2',
      sizeMappingName: 'LL',
    },
    {
      id: 'dlab_ad_D1',
      path: '/2273514/stol_dolo_but_1',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_D2',
      path: '/2273514/stol_dolo_but_2',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_D3',
      path: '/2273514/stol_dolo_but_3',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_D4',
      path: '/2273514/stol_dolo_but_4',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_D5',
      path: '/2273514/stol_dolo_but_5',
      sizeMappingName: 'BUTTON',
    },
    {
      id: 'dlab_ad_D6',
      path: '/2273514/stol_dolo_but_6',
      sizeMappingName: 'BUTTON',
    },
  ],

  general: {
    reloadInterval: true,
    collapseEmptyDivs: true,
    disableInitialLoad: true,
    enableSingleRequest: false,
    testValue: '1',
    preloadedFiles: [
      {
        link: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
        async: true,
      },
    ],
    // reloader: {
    //   interval: 30,
    //   campaignIds: [293423654, 164280974],
    //   adUnitsIds: ['/2273514/stol7_hp_sky', '/2273514/stol7_default_sky'],
    // },
    // addCloseButton: {
    //   elements: [
    //     {
    //       ids: ['dlab_ad_H2', 'dlab_ad_S2'],
    //       width: [728],
    //     },
    //   ],
    // },
  },
}

export default stolConfig
